import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';
import { MEDIA_SOCIAL_PLAYER_LIST } from 'src/constants/queryKeys';

export const networkGetMediaSocialPlayerInfo = async (mediaSocialPlayerId) => {
  const res = await axiosInstance.post(`MediaSocialPlayer/Info/${mediaSocialPlayerId}`);
  return res;
};

export const networkGetMediaSocialPlayerList = async (payload, pageIndex, pageSize) => {
  const res = await axiosInstance.post(`MediaSocialPlayer/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchMediaSocialPlayerList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [MEDIA_SOCIAL_PLAYER_LIST, payload, pageIndex],
    queryFn: () => {
      return networkGetMediaSocialPlayerList(payload, pageIndex, pageSize);
    },
  });
}

export const networkCreateMediaSocialPlayer = async (data) => {
  const res = await axiosInstance.post('MediaSocialPlayer/Insert', data);
  return res;
};

export const networkUpdateMediaSocialPlayer = async (mediaSocialPlayerId, data) => {
  const res = await axiosInstance.post(`MediaSocialPlayer/Update/${mediaSocialPlayerId}`, data);
  return res;
};

export const networkRemoveMediaSocialPlayer = async (mediaSocialPlayerId) => {
  const res = await axiosInstance.post(`MediaSocialPlayer/Remove/${mediaSocialPlayerId}`);
  return res;
};
